import apiClient from '@/services/axios'

export async function get() {
  
  var response = await apiClient.get(process.env.VUE_APP_CRM_API_BASE_URL + '/LegalDocuments/DataController')
  if (response) {
    return response.data
  }

  throw new Error('Unable to get data controller')
}
